// extracted by mini-css-extract-plugin
export default {"banner":"PromotionBanner_banner__dL3T2","icon":"PromotionBanner_icon__NPkHZ","text":"PromotionBanner_text__JAc4p","countdown":"PromotionBanner_countdown__lCbbA"};